import { render, staticRenderFns } from "./TheImage.vue?vue&type=template&id=473236b9&scoped=true"
import script from "./TheImage.vue?vue&type=script&lang=ts"
export * from "./TheImage.vue?vue&type=script&lang=ts"
import style0 from "./TheImage.vue?vue&type=style&index=0&id=473236b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473236b9",
  null
  
)

export default component.exports